import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { AnimationSettingsModel } from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import {
  addTrainingSettings,
  deleteTrainingSettings,
  editTrainingSettings,
  getTrainingSettings,
} from '../../../services/Position/PositionServices';
import Message from '../../../utils/Message/Message';
interface IProps {}
interface IState {
  TrainingCategoriesData: Array<any>;
}
class TrainingCategories extends Component<IProps, IState> {
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public validationNumberRule: Object = { required: true, number: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private animationSettings: AnimationSettingsModel;
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: 'Top',
  };
  private gridTrainingCategoriesObj: any;
  private type: string = 'categorie';
  constructor(props: IProps) {
    super(props);
    this.state = {
      TrainingCategoriesData: [],
    };
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
  }
  async getTrainingCategories() {
    await getTrainingSettings(this.type).then((res) => {
      let model = res.data.map((items: any) => {
        return {
          ...items,
        };
      });
      this.setState({ TrainingCategoriesData: model });
    });
  }
  actionBeginPosition(args: any) {
    if (args.action === 'add') {
      this.savePointAddTrainingCategories(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditTrainingCategories(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteTrainingCategories(args.data);
    }
  }
  componentDidMount() {
    this.getTrainingCategories();
  }
  savePointAddTrainingCategories(obje: any) {
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      name: obje.name,
      code: obje.code,
      created_by: all_information.user_id,
      type: this.type,
    });
    addTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getTrainingCategories();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditTrainingCategories(obje: any) {
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      name: obje.name,
      code: obje.code,
      created_by: all_information.user_id,
      ID: obje.ID,
      type: this.type,
    });
    editTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getTrainingCategories();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteTrainingCategories(obje: any) {
    const obj = JSON.stringify({
      ID: obje[0].ID,
    });
    deleteTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getTrainingCategories();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  private toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getTrainingCategories();
    }
    if (
      this.gridTrainingCategoriesObj &&
      args.item.id === 'gridTrainingCategories_excelexport'
    ) {
      this.gridTrainingCategoriesObj.excelExport();
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridTrainingCategories'
          dataSource={this.state.TrainingCategoriesData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridTrainingCategoriesObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          allowExcelExport={true}
          showColumnChooser
          pageSettings={this.pageOptions}
          toolbarClick={this.toolbarClick.bind(this)}
          showColumnMenu={true}
          // enablePersistence
          allowResizing={true}
          allowGrouping={true}
          style={{ display: 'inline-block' }}
          gridLines='Both'
          height='calc(-220px + 100vh)'
          actionBegin={this.actionBeginPosition.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='name'
              validationRules={this.validationRule}
              headerText='Name'
            />
            <ColumnDirective
              field='code'
              validationRules={this.validationRule}
              headerText='Code'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}
export default TrainingCategories;
